import uuidService from '@/services/uuid.service';
import ICAL from 'ical.js';
import { Frequency, RRule, rrulestr } from 'rrule';
import { Temporal } from 'temporal-polyfill';
import { ICalEvent } from './ical-event';

function create(values?: Partial<ICalEvent>): ICalEvent {
	return {
		...values,
		UID: values?.UID ?? uuidService.v4(),
		DTSTAMP: values?.DTSTAMP ?? Temporal.Now.zonedDateTimeISO(),
		DTSTART: values?.DTSTART ?? Temporal.Now.zonedDateTimeISO(),
	};
}

function setFrequency(event: ICalEvent, freq?: Frequency): ICalEvent {
	switch (freq) {
		case undefined:
			return {
				...event,
				RRULE: new RRule({ dtstart: new Date(event.DTSTART.toInstant().epochMilliseconds), tzid: event.DTSTART.timeZoneId }),
			};
		case RRule.WEEKLY: {
			const value: ICalEvent = {
				...event,
				RRULE: new RRule({ dtstart: new Date(event.DTSTART.toInstant().epochMilliseconds), tzid: event.DTSTART.timeZoneId, freq: RRule.WEEKLY, byweekday: [] }),
			};
			return value;
		}
		default:
			return {
				...event,
				RRULE: new RRule({ dtstart: new Date(event.DTSTART.toInstant().epochMilliseconds), tzid: event.DTSTART.timeZoneId, freq }),
			};
	}
}

function icalEventToDomainEvent(icalEvent: ICAL.Event): ICalEvent {
	const start = _icalTimeToTemporal(icalEvent.startDate) as Temporal.ZonedDateTime;
	const rruleString = icalEvent.component.getFirstProperty('rrule')?.toICALString();
	const rruleRaw = rruleString ? rrulestr(rruleString) : undefined;
	const rrule = rruleRaw ? new RRule({
		...rruleRaw.origOptions,
		dtstart: new Date(start.toInstant().epochMilliseconds),
		tzid: _getTimeZone(icalEvent.startDate)
	}) : undefined;

	const dtStampRaw = icalEvent.component.getFirstPropertyValue('dtstamp') as ICAL.Time;
	const dtStamp = _icalTimeToTemporal(dtStampRaw) as Temporal.ZonedDateTime;


	return {
		DTSTAMP: dtStamp,
		DTSTART: start,
		DTEND: _icalTimeToTemporal(icalEvent.endDate),
		UID: icalEvent.uid,
		summary: icalEvent.summary,
		RRULE: rrule,
	}

}

function domainEventToIcalEvent(icalEvent: ICalEvent): ICAL.Event {
	const vevent = new ICAL.Component('vevent');


	if (icalEvent.RRULE) {
		const rrule = ICAL.Property.fromString('RRULE:' + icalEvent.RRULE.toString().split('RRULE:')[1]);
		vevent.addProperty(rrule);
	}


	const event = new ICAL.Event(vevent);

	event.startDate = _temporalToICalTime(icalEvent.DTSTART)
	if (icalEvent.DTEND) {
		event.endDate = _temporalToICalTime(icalEvent.DTEND);
	}
	event.summary = icalEvent.summary ?? '';
	event.uid = icalEvent.UID;



	return event;
}

function _icalTimeToTemporal(time?: ICAL.Time): Temporal.ZonedDateTime | undefined {
	if (!time) {
		return undefined
	};

	/**
	 * FIXME: This is an ugly fix because our 
	 */
	const timezone = _getTimeZone(time);

	return Temporal.ZonedDateTime.from({
		timeZone: timezone,
		timeZoneId: timezone,
		year: time.year,
		month: time.month,
		day: time.day,
		hour: time.hour,
		minute: time.minute,
		second: time.second,
	})
}

function _getTimeZone(time: ICAL.Time): string {
	return time.zone.tzid === 'floating' ? (time as any).timezone : time.zone.tzid;
}

function _temporalToICalTime(time: Temporal.ZonedDateTime): ICAL.Time {
	const timeZoneComp = new ICAL.Component('vtimezone');
	const zone = new ICAL.Timezone({ component: timeZoneComp, tzid: time.timeZoneId });

	return new ICAL.Time({
		year: time.year,
		month: time.month,
		day: time.day,
		hour: time.hour,
		minute: time.minute,
		second: time.second,
	}, zone);
}


export default { create, setFrequency, icalEventToDomainEvent, domainEventToIcalEvent };
